<template>
  <!--   <div ref="holder" :class="holderclasses"> -->
  <div ref="holder" :class="holderclasses">
    <div ref="zoom_level" style="overflow: hidden; line-height: 16px;">
      {{ $t('zoom_level') }} {{ Math.round(workflow_interface.scale * 100) }} %
    </div>
    <div
      :style="{
        height: elements_size.effective_map_height + 'px',
      }"
      class="d-flex"
    >
      <!--       <div
        style="
          position: relative;
          width: 448px;
          height: 252px;
          background-color: #eeeeee;
          overflow: hidden;
        "
      > -->
      <!--       <div
        style="position: relative; background-color: #eeeeee; overflow: hidden;"
        :style="{
          width: palette_width + 'px',
          height: (palette_width * 252) / 448 + 'px',
        }"
      > -->
      <!--       <div
        style="position: relative; background-color: #eeeeee; overflow: hidden;"
        :style="{
          width: elements_size.map_width + 'px',
          height: elements_size.map_height + 'px',
        }"
      > -->
      <!--       <div
        class="flex-w-stretch flex-h-stretch"
        style="position: relative; background-color: #eeeeee; overflow: hidden;"
        :style="{
          width: elements_size.effective_map_width + 'px',
          height: elements_size.effective_map_height + 'px',
        }"
      > -->
      <!--       <div
        style="position: relative; background-color: #eeeeee; overflow: hidden;"
        :style="{
          width: elements_size.effective_map_width + 'px',
          height: elements_size.effective_map_height + 'px',
        }"
      > -->
      <div
        style="position: relative; background-color: #eeeeee; overflow: hidden;"
        :style="{
          width: elements_size.effective_map_width + 'px',
        }"
      >
        <div
          ref="currentarea"
          style="position: absolute; opacity: 0.5; touch-action: none;"
          class="bg-lightgrey border border-darkgrey"
        />
        <div
          v-for="suid in bricks_undeleted.lists"
          :key="suid"
          :style="thumbnail_brick_style(suid)"
        />
        <div
          ref="sonar0"
          v-if="even_sonar"
          :style="sonar_style"
          class="pulse border-blue"
        />
        <div
          ref="sonar1"
          v-if="odd_sonar"
          :style="sonar_style"
          class="pulse border-blue"
        />
      </div>

      <!--       <div class="btn-group-vertical"> -->
      <div class="btn-group-vertical align-self-stretch flex-h-stretch h-100">
        <b-button
          :pressed="workflow_interface.show_grid"
          @click="toggle_grid"
          variant="outline-primary"
          size="sm"
          class="py-0"
          :style="minimap_button_style"
        >
          <span class="mdi mdi-grid fa-fw" />
        </b-button>

        <b-button
          :pressed="workflow_interface.show_descriptions"
          @click="toggle_descriptions"
          variant="outline-primary"
          size="sm"
          class="py-0"
          :style="minimap_button_style"
        >
          <span class="mdi mdi-text-short fa-fw" />
        </b-button>

        <b-button
          @click="zoom_out"
          variant="outline-primary"
          size="sm"
          class="py-0"
          :style="minimap_button_style"
        >
          <span class="fas fa-search-minus fa-fw" />
        </b-button>

        <b-button
          @click="zoom_reset"
          variant="outline-primary"
          size="sm"
          class="py-0"
          :style="minimap_button_style"
        >
          <span class="fas fa-search fa-fw" />
        </b-button>

        <b-button
          @click="zoom_in"
          variant="outline-primary"
          size="sm"
          class="py-0"
          :style="minimap_button_style"
        >
          <span class="fas fa-search-plus fa-fw" />
        </b-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.prevent-select {
  user-select: none;
}

// .pulse {
//   position: absolute;
//   border-radius: 0px;
//   border-style: solid;
//   box-sizing: border-box;
//   -webkit-animation-name: tpulse;
//   -webkit-animation-duration: 10s;
//   border-width: 2px;
//   opacity: 0.95;
//   -webkit-transform: scale(1);
//   width: 20px;
//   height: 20px;
//   opacity: 0;
// }

// @-webkit-keyframes tpulse {
//   0% {
//     border-width: 4px;
//     -webkit-transform: scale(4);
//     opacity: 0;
//     width: 64px;
//     height: 64px;
//   }
//   50% {
//     border-width: 2px;
//     opacity: 0.95;
//     -webkit-transform: scale(1);
//     width: 20px;
//     height: 20px;
//   }
//   100% {
//     opacity: 0;
//   }
// }

/* @-webkit-keyframes tpulse {
  0% {
    border-width: 4px;
    opacity: 0;
    -webkit-transform: scale(16);
    width: 16px;
    height: 16px;
  }
  4% {
    border-width: 4px;
    -webkit-transform: scale(4);
    opacity: 0;
    width: 64px;
    height: 64px;
  }
  16% {
    border-width: 2px;
    opacity: 0.95;
    -webkit-transform: scale(1);
    width: 20px;
    height: 20px;
  }
  99% {
  }
  100% {
    opacity: 0;
  }
}
 */
</style>

<i18n>
{
  "en": {
    "zoom_level": "Zoom level:"
  },
  "fr": {
    "zoom_level": "Niveau de zoom :"
  }
}
</i18n>

<script>
import _ from 'lodash'
import $ from 'jquery'

import { mapState, mapGetters } from 'vuex'

import { project_mixin } from '@/components/mixin.js'

import { workflow_brick_size } from '@/utils.js'
import { scale_from_scale_index, color_from_name } from './workflow_common.js'
import chartColors from '@/components/chart_colors.js'

import { dynamic_css_rule_manager } from '@/dynamic_css_rule_manager.js'
import { WorkflowMinimapHandler } from './workflow_core.vue'

// *****************************************************************************

export default {
  name: 'WorkflowMinimap',
  components: {},
  mixins: [project_mixin],
  props: ['workflow_interface', 'options', 'canvas_size'],
  data() {
    let res = {
      pulse_cssrule_id: undefined,
      tpulse_cssrule_id: undefined,
      even_sonar: false,
      odd_sonar: false,
      sonar_position: { x: 0, y: 0 },
    }
    return res
  },
  computed: {
    // project_id() {
    //   let route = this.$route.path
    //   let regexp = new RegExp('(\\d)*/workflow')
    //   return Number(route.match(regexp)[0].split('/')[0])
    // },
    bricks_undeleted() {
      return this.automl_bricks_undeleted_object_per_project(this.project_id)
    },
    holderclasses() {
      return ['prevent-select']
    },
    running_bricks() {
      return this.platform_status.current_running_brick_ids.toArray()
    },
    // viewport_pos() {
    //   let { x, y } = this.automl_workflow_pos
    //   let { width, height } = this.canvas_size
    //   let scale = scale_from_scale_index(this.automl_workflow_zoom_level)
    //   let scale_factor = 448.0 / (3860 * scale)
    //   x *= scale_factor
    //   y *= scale_factor
    //   width *= scale_factor
    //   height *= scale_factor
    //   return { x, y, width, height }
    // },
    viewport_pos() {
      let { x, y } = this.automl_workflow_pos
      let { width, height } = this.canvas_size
      let { workflow_width, workflow_height } = {
        workflow_width: 3840,
        workflow_height: 2160,
      }
      let scale = scale_from_scale_index(this.automl_workflow_zoom_level)
      // let scale_factor = 448.0 / (3860 * scale)
      let horizontal_scale_factor =
        this.elements_size.effective_map_width / (workflow_width * scale)
      let vertical_scale_factor =
        this.elements_size.effective_map_height / (workflow_height * scale)
      // console.log(x, y, width, height)
      // console.log(this.elements_size.effective_map_width, workflow_width)
      // console.log(this.elements_size.effective_map_height, workflow_height)
      // console.log(scale, horizontal_scale_factor, vertical_scale_factor)

      x *= horizontal_scale_factor
      y *= vertical_scale_factor
      width *= horizontal_scale_factor
      height *= vertical_scale_factor
      let res = { x, y, width, height }
      // console.log(res)
      return res
    },
    sonar_style() {
      let { x, y } = this.sonar_position
      return `left: ${x}px;top: ${y}px;`
    },
    scale_factors() {
      let { workflow_width, workflow_height } = {
        workflow_width: 3840,
        workflow_height: 2160,
      }
      let scale = scale_from_scale_index(this.automl_workflow_zoom_level)
      // let scale_factor = 448.0 / (3860 * scale)
      let horizontal_scale_factor =
        this.elements_size.effective_map_width / (workflow_width * scale)
      let vertical_scale_factor =
        this.elements_size.effective_map_height / (workflow_height * scale)
      return { horizontal_scale_factor, vertical_scale_factor }
    },
    // palette_width() {
    //   return (this.window_size.height / 5.5) * (448 / 270)
    // },
    // elements_size() {
    //   let res = {}
    //   let map_ratio = 252 / 448

    //   res.map_width = this.palette_width
    //   res.map_height = res.map_width * map_ratio

    //   return res
    // },

    minimap_button_style() {
      let res = {
        'font-size': this.elements_size.info_panel_button_fontsize + 'px',
      }

      return res
    },
    ...mapState([
      'automl_workflow_zoom_level',
      'automl_workflow_pos',
      'automl_workflow_viewport',
      'platform_status',
      'elements_size',
    ]),
    ...mapGetters(['automl_bricks_undeleted_object_per_project']),
  },
  watch: {
    viewport_pos(nv) {
      let { x, y, width, height } = nv
      let s = this.$refs.currentarea.style
      s.left = `${x}px`
      s.top = `${y}px`
      s.width = `${width}px`
      s.height = `${height}px`
    },
    scale_factors(nv, ov) {
      // console.log('scale_factors', nv, ov)
      const { horizontal_scale_factor, vertical_scale_factor } = nv
      const small_border = 2 * 9 * horizontal_scale_factor
      const large_border = 4 * 9 * horizontal_scale_factor
      const small_width = 20 * 9 * horizontal_scale_factor
      const large_width = 64 * 9 * horizontal_scale_factor
      const small_height = 20 * 9 * vertical_scale_factor
      const large_height = 64 * 9 * vertical_scale_factor
      dynamic_css_rule_manager.set_rule(
        this.pulse_cssrule_id,
        '.pulse',
        `
  position: absolute;
  border-radius: 0px;
  border-style: solid;
  box-sizing: border-box;
  -webkit-animation-name: tpulse;
  -webkit-animation-duration: 10s;
  border-width: ${small_border}px;
  opacity: 0.95;
  -webkit-transform: scale(1);
  width: ${small_width}px;
  height: ${small_height}px;
  opacity: 0;
`
      )

      dynamic_css_rule_manager.set_rule(
        this.tpulse_cssrule_id,
        '@-webkit-keyframes tpulse',
        `
  0% {
    border-width: ${large_border}px;
    -webkit-transform: scale(4);
    opacity: 0;
    width: ${large_width}px;
    height: ${large_height}px;
  }
  50% {
    border-width: ${small_border}px;
    opacity: 0.95;
    -webkit-transform: scale(1);
    width: ${small_width}px;
    height: ${small_height}px;
  }
  100% {
    opacity: 0;
  }
`
      )
    },
    running_bricks(nv, ov) {
      // console.log(nv, ov)
      if (nv != ov) {
        if (nv.length === 0) {
          return
        }
        if (this.odd_sonar) {
          this.odd_sonar = false
          this.even_sonar = true
        } else {
          this.odd_sonar = true
          this.even_sonar = false
        }
        let brick = this.bricks_undeleted.bricks[nv[0]]
        if (_.isUndefined(brick)) {
          return
        }
        let { x, y } = brick.position

        let { workflow_width, workflow_height } = {
          workflow_width: 3840,
          workflow_height: 2160,
        }
        let scale = scale_from_scale_index(this.automl_workflow_zoom_level)
        // let scale_factor = 448.0 / (3860 * scale)
        let horizontal_scale_factor =
          this.elements_size.effective_map_width / (workflow_width * scale)
        let vertical_scale_factor =
          this.elements_size.effective_map_height / (workflow_height * scale)

        // let scale = 448 / 3840
        // x = x * horizontal_scale_factor - 10
        // y = y * vertical_scale_factor - 10
        x = (x - 40 - 48) * horizontal_scale_factor
        y = (y - 40 - 48) * vertical_scale_factor
        this.sonar_position = { x, y }
      }
    },
  },
  mounted() {
    this.pulse_cssrule_id = dynamic_css_rule_manager.acquire_rule()
    this.tpulse_cssrule_id = dynamic_css_rule_manager.acquire_rule()

    //     dynamic_css_rule_manager.set_rule(
    //       this.pulse_cssrule_id,
    //       '.pulse',
    //       `
    //   position: absolute;
    //   border-radius: 0px;
    //   border-style: solid;
    //   box-sizing: border-box;
    //   -webkit-animation-name: tpulse;
    //   -webkit-animation-duration: 10s;
    //   border-width: 2px;
    //   opacity: 0.95;
    //   -webkit-transform: scale(1);
    //   width: 20px;
    //   height: 20px;
    //   opacity: 0;
    // `
    //     )

    //     dynamic_css_rule_manager.set_rule(
    //       this.tpulse_cssrule_id,
    //       '@-webkit-keyframes tpulse',
    //       `
    //   0% {
    //     border-width: 4px;
    //     -webkit-transform: scale(4);
    //     opacity: 0;
    //     width: 64px;
    //     height: 64px;
    //   }
    //   50% {
    //     border-width: 2px;
    //     opacity: 0.95;
    //     -webkit-transform: scale(1);
    //     width: 20px;
    //     height: 20px;
    //   }
    //   100% {
    //     opacity: 0;
    //   }
    // `
    //     )
    //     dynamic_css_rule_manager.set_rule(
    //       this.pulse_cssrule_id,
    //       '.pulse',
    //       `
    //   position: absolute;
    //   border-radius: 0px;
    //   border-style: solid;
    //   box-sizing: border-box;
    //   -webkit-animation-name: tpulse;
    //   -webkit-animation-duration: 10s;
    //   border-width: 2px;
    //   opacity: 0.95;
    //   -webkit-transform: scale(1);
    //   width: 20px;
    //   height: 20px;
    //   opacity: 0;
    // `
    //     )

    //     dynamic_css_rule_manager.set_rule(
    //       this.tpulse_cssrule_id,
    //       '@-webkit-keyframes tpulse',
    //       `
    //   0% {
    //     border-width: 4px;
    //     -webkit-transform: scale(4);
    //     opacity: 0;
    //     width: 64px;
    //     height: 64px;
    //   }
    //   50% {
    //     border-width: 2px;
    //     opacity: 0.95;
    //     -webkit-transform: scale(1);
    //     width: 20px;
    //     height: 20px;
    //   }
    //   100% {
    //     opacity: 0;
    //   }
    // `
    //     )

    this.handler = new WorkflowMinimapHandler(this)
    this.workflow_interface.install(this.handler)
    this.$store.commit(
      'set_zoom_level_height',
      $(this.$refs.zoom_level).height()
    )
  },
  beforeDestroy() {
    this.handler.stop()
    this.workflow_interface.uninstall(this.handler)
    dynamic_css_rule_manager.release_rule(this.tpulse_cssrule_id)
    dynamic_css_rule_manager.release_rule(this.pulse_cssrule_id)
  },
  methods: {
    toggle_grid() {
      this.workflow_interface.show_grid = !this.workflow_interface.show_grid
    },
    toggle_descriptions() {
      this.workflow_interface.show_descriptions = !this.workflow_interface
        .show_descriptions
    },
    toggle_all_bricks() {
      this.workflow_interface.show_all_bricks = !this.workflow_interface
        .show_all_bricks
    },
    zoom_in() {
      this.workflow_interface.set_scale(this.workflow_interface.scale_index + 1)
    },
    zoom_out() {
      this.workflow_interface.set_scale(this.workflow_interface.scale_index - 1)
    },
    zoom_reset() {
      this.workflow_interface.set_scale(0)
    },
    thumbnail_brick_style(suid) {
      let { workflow_width, workflow_height } = {
        workflow_width: 3840,
        workflow_height: 2160,
      }
      let scale = scale_from_scale_index(this.automl_workflow_zoom_level)
      // let scale_factor = 448.0 / (3860 * scale)
      let horizontal_scale_factor =
        this.elements_size.effective_map_width / (workflow_width * scale)
      let vertical_scale_factor =
        this.elements_size.effective_map_height / (workflow_height * scale)

      let width = workflow_brick_size * horizontal_scale_factor
      let height = workflow_brick_size * vertical_scale_factor

      let brick = this.bricks_undeleted.bricks[suid]
      let { x, y } = brick.position
      let offset = workflow_brick_size / 2
      x = (x - offset) * horizontal_scale_factor
      y = (y - offset) * vertical_scale_factor
      let color = chartColors[color_from_name(brick.brick_name)]
      return `position: absolute; width: ${width}px; height: ${height}px; background-color: ${color}; left: ${x}px; top: ${y}px`

      // let brick = this.bricks_undeleted.bricks[suid]
      // let { x, y } = brick.position
      // let scale = 448 / 3840
      // let size = workflow_brick_size * scale
      // let offset = workflow_brick_size / 2
      // x = (x - offset) * scale
      // y = (y - offset) * scale
      // let color = chartColors[color_from_name(brick.brick_name)]
      // return `position: absolute; width: ${size}px; height: ${size}px; background-color: ${color}; left: ${x}px; top: ${y}px`
    },
  },
}
</script>
